<!-- DECLARE PAYMENT -->
<p-dialog
  class="filters-modal"
  [header]="'Declara tu depósito'"
  [modal]="true"
  [(visible)]="showDeclarePaymentModal"
  [style]="{ width: '450px' }"
  *ngIf="showDeclarePaymentModal"
  [closable]="!declaring"
  closeOnEscape="false"
  (visibleChange)="exit()"
>
  <div class="wallets-container">
    <!-- SELECT NETWORK -->
    <div class="wallet-picker">
      <form class="form-container" [formGroup]="paymentForm">
        <div class="form-row">
          <div class="filter-column declare-column">
            <div class="form-item">
              <label for="status" *ngIf="currencyType === 'crypto'">
                Monto recargado
              </label>
              <label for="status" *ngIf="currencyType === 'fiat'">
                Monto transferido
              </label>
              <p-inputNumber
                [useGrouping]="true"
                formControlName="amount"
                autocomplete="off"
                [placeholder]="token + ' 0.00'"
                [prefix]="token + ' '"
                class="id-input-filter"
                mode="decimal"
                [minFractionDigits]="2"
                [maxFractionDigits]="8"
              />
            </div>

            <!-- <div class="form-item" *ngIf="type === 'virtual_card'">
              <label for="status"> Monto recargado</label>
              <span>{{ token }} {{ getValue() | number: "1.2-8" }}</span>
            </div> -->

            <div class="form-item" *ngIf="currencyType === 'fiat'">
              <label for="status">Referencia bancaria</label>
              <input
                pInputText
                formControlName="reference"
                autocomplete="off"
                placeholder="Ingresa la referencia del banco"
              />
            </div>
            <div class="form-item" *ngIf="currencyType === 'crypto'">
              <label for="status">Hashrate resultante</label>
              <input
                pInputText
                formControlName="reference"
                autocomplete="off"
                placeholder="Ingresa el hashrate resultante"
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="buttons-container">
    <p-button
      label="Volver"
      severity="secondary"
      *ngIf="!declaring"
      (click)="exit()"
    />
    <p-button
      [label]="declaring ? 'Declarando depósito' : 'Declarar depósito'"
      severity="secondary"
      [disabled]="declaring || paymentForm.invalid"
      [loading]="declaring"
      (click)="declarePayment()"
    />
  </div>
</p-dialog>
